import { page } from '$app/state';
import { translations, type I18nKey, type Locale } from './translations';

function getBrowserPreferred(): Locale {
	const browserPreferred = navigator?.languages[0].split('-')[0];
	return (browserPreferred || 'de') as Locale;
}

class Translator {
	locale = $derived(page.data.loggedInUser?.locale || getBrowserPreferred());
	translate = $derived((key: I18nKey, vars: Record<string, string | number> = {}) => {
		const localeTranslations = translations[this.locale] || translations.de;
		const template = localeTranslations[key] || translations.de[key] || `${key}-i18n-missing`;

		const text = Object.entries(vars).reduce((accT, [key, value]) => {
			const regex = new RegExp(`{{${key}}}`, 'g');
			return accT.replace(regex, '' + value);
		}, template);

		return text;
	});
}

export const translator = new Translator();

/**
 * Convenince for templates
 * @param key
 * @param vars
 * @returns
 */
export function t(key: I18nKey, vars: Record<string, string | number> = {}) {
	return translator.translate(key, vars);
}
